<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  export let showFirstEditModal: boolean;
  export let onCloseFirstEditModal: any;

  function startEditing() {
    showFirstEditModal = false;
    onCloseFirstEditModal();
  }
</script>

<Modal
  bind:show={showFirstEditModal}
  closeOnBackgroundClick={false}
  fizzModal={true}
  center={true}
  wide={true}
>
  <h2 class="fizz-heading-1 fizz-stack-32 fizz-text-center">Welcome to your Storefront Editor</h2>

  <ul class="fizz-flow-24 fizz-stack-32">
    <li class="fizz-flex-row-32 fizz-align-content-start">
      <Icon type="Highlight" height="32" width="32"></Icon>
      <p
        ><strong>Highlight Products in Your Catalog</strong><br />
        <span class="fizz-text-small"
          >Drive awareness and sales to specific products in your portfolio.</span
        ></p
      >
    </li>
    <li class="fizz-flex-row-32 fizz-align-content-start">
      <Icon type="PaintBrush" height="32" width="32"></Icon>
      <p
        ><strong>Design &amp; Customize</strong><br />
        <span class="fizz-text-small"
          >Use predetermined templates and add custom photos to design a visually appealing
          Storefront in minutes—no coding required.</span
        ></p
      >
    </li>
    <li class="fizz-flex-row-32 fizz-align-content-start">
      <Icon type="Question" height="32" width="32"></Icon>
      <p
        ><strong>Need help?</strong><br />
        <span class="fizz-text-small"
          >Discover best practices and learn more about updating your Storefront by visiting our <a
            href={`https://support.provi.com/s/topic/0TODn000000YINAOA4/storefronts`}>help desk</a
          >.</span
        ></p
      >
    </li>
  </ul>

  <button class="fizz-button-primary cursor-pointer" on:click={startEditing}>Start Editing</button>
</Modal>
